import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '~/styles/Utils';

const PresetButton = styled.button`
  padding: 5px;
  flex-shrink: 1;
  font-size: 13px;
  display: block;
  padding: 6px 12px;
  border: none;
  background: white;
  outline: none;
  color: ${(p) => p.theme.colors.interaction};
  border-radius: 4px;
  transition: background 200ms, color 200ms, border 200ms;
  border: 1px solid ${(p) => p.theme.colors.interaction};

  ${(props) =>
    props.isActive &&
    css`
      cursor: pointer;
      background: ${(p) => p.theme.colors.interaction};
      color: white;
      border-color: ${(p) => p.theme.colors.interaction};

      ${media.m`
      &:hover {
        color: ${(p) => p.theme.colors.interaction};
        background: #eee;
        border: 1px solid ${(p) => p.theme.colors.interaction};
      }
      `}
    `}
`;

const HiddenFakeLabel = styled.span`
  display: block;
  height: 0px;
  overflow: hidden;
  font-size: 1em;
  font-weight: bold;
  opacity: 0;
  visibility: hidden;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button {
    margin-bottom: 5px;
  }

  button:last-child {
    margin-bottom: 0;
  }
`;

export default ({ children, ...props }) => (
  <PresetButton {...props}>
    {children}
    <HiddenFakeLabel>{children}</HiddenFakeLabel>
  </PresetButton>
);
